import { render, staticRenderFns } from "./probottom.vue?vue&type=template&id=48429617&"
import script from "./probottom.vue?vue&type=script&lang=js&"
export * from "./probottom.vue?vue&type=script&lang=js&"
import style0 from "./probottom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports